import { apiFolioGetReport, apiProductoGetObtenerProducto } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { getFormFiltroFolios, getModelFolio } from "../models/FolioModel";
import { green, red } from "@material-ui/core/colors";

import { fnHandleChangeText } from "../settings/handleConfig";
import { useLayout } from "./LayoutContext";
import { useRequest } from "./RequestContext";

export const FolioContext = createContext();

export function FolioProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { Get } = useRequest();

    const [listaProductos, setListaProductos] = useState([]);
    const [listaFolios, setListaFolios] = useState([]);
    const [folioSeleccionado, setFolioSeleccionado] = useState(getModelFolio());
    const [modalOpenDetalleFolio, setModalOpenDetalleFolio] = useState(false);
    const [formFiltroFolios, setFormFiltroFolios] = useState(getFormFiltroFolios());

    const handleOpenDetalleFolio = (value) => {
        setModalOpenDetalleFolio(value);
    };

    const handleChangeFolioSeleccionado = (value) => {
        setFolioSeleccionado(value);
    };

    const handleChangeFormFiltroFolios = fnHandleChangeText(formFiltroFolios, setFormFiltroFolios);

    const handleClickDetalleFolio = () => {
        if (folioSeleccionado.iIdFolio === 0) {
            handleOpenAlert("Seleccione el folio para ver el detalle");
            return;
        }
        setModalOpenDetalleFolio(true);
    };

    const handleClickRefrescarDatos = async () => {
        await fnObtenerProductos();
        await fnObtenerFolios();
        setFormFiltroFolios(getFormFiltroFolios());
        setFolioSeleccionado(getModelFolio());
    };

    const handleClickFiltrarFolios = () => {
        const { txtOrigen, txtProducto, txtVigente } = formFiltroFolios;

        fnObtenerFolios(txtProducto.value, txtOrigen.value, true, false, txtVigente.value);
    };

    const fnObtenerProductos = async () => {
        const payload = {
            loader: "Consultando productos...",
            url: apiProductoGetObtenerProducto,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaProductos(response.Result);
        }
    };

    const fnObtenerFolios = async (
        piIdProducto = "",
        piIdOrigen = "",
        pbActivo = true,
        pbBaja = false,
        pbVigente = ""
    ) => {
        const payload = {
            loader: "Consultando folios de empresa...",
            url:
                apiFolioGetReport +
                "?piIdProducto=" +
                piIdProducto +
                "&piIdOrigen=" +
                piIdOrigen +
                "&pbActivo=" +
                pbActivo +
                "&pbBaja=" +
                pbBaja +
                "&pbVigente=" +
                pbVigente,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaFolios(
                response.Result.map((folio) => ({
                    ...folio,
                    sStatus: (
                        <span>
                            <i
                                className="icon size-20"
                                style={{
                                    color: folio.bVigente === true ? green[500] : red[500],
                                    verticalAlign: "middle",
                                }}
                                dangerouslySetInnerHTML={{ __html: `&#x${folio.sIcon}` }}
                            />
                        </span>
                    ),
                }))
            );
        }
    };

    return (
        <FolioContext.Provider
            value={{
                listaProductos,
                listaFolios,
                folioSeleccionado,
                modalOpenDetalleFolio,
                formFiltroFolios,
                handleOpenDetalleFolio,
                handleChangeFolioSeleccionado,
                handleChangeFormFiltroFolios,
                handleClickDetalleFolio,
                handleClickRefrescarDatos,
                handleClickFiltrarFolios,
            }}
        >
            {props.children}
        </FolioContext.Provider>
    );
}

export function useFolio() {
    return useContext(FolioContext);
}
